import { Component, ViewChild, NgZone } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ParkbewilligungenData, PbActions, PbKategorieTyp } from '../../parkbewilligungen-data';
import { AdditionalfieldsData } from '../../../../providers/additionalfields-data';
import { UserData } from '../../../../providers/user-data';
import { MandantenData } from '../../../../providers/mandanten-data';
import { PbcatrulesComponent } from "../../../../components/pbcatrules/pbcatrules";
import { AdditionalfieldsComponent } from "../../../../components/additionalfields/additionalfields";
import { ToastController } from 'ionic-angular';
import { CommonData } from '../../../../providers/common-data';


@Component({
  selector: 'page-pbkategorien-edit',
  templateUrl: 'pbkategorien-edit.html',
})
export class PbkategorienEditPage {
  public pbkat: any;
  public pbregelnbycatid: any;
  public bestellurl: string;
  public periodcount: number;
  public PbKategorieTyp = PbKategorieTyp;
  public customertab = "catinfo";  
  public readonly: boolean = false;
  @ViewChild(PbcatrulesComponent) catrules:PbcatrulesComponent;
  @ViewChild(AdditionalfieldsComponent) additionalfields:AdditionalfieldsComponent;

  constructor(
    public navCtrl: NavController
    , public navParams: NavParams
    , public pbData: ParkbewilligungenData
    , public userData: UserData
    , public mandantenData: MandantenData
    , public toastCtrl: ToastController
    , public common: CommonData
    , public zone: NgZone,
    ) {

    this.periodcount = 0;

    if(navParams.data.id>0){      
      this.pbData.pbcatbyid(navParams.data.id).then(res => {
        //console.log(res);
        this.pbkat = res;
        this.readonly = (this.pbkat.archiviert == 1);
        //console.log(this.pbkat);
        this.updateBestellURL();    
        this.loadPeriodcount();    
        //this.oSelectedKategorieRegeln = res;
      });    
      
      this.pbData.pbregelnbycatid(navParams.data.id).then(res => {
        //console.log(res);
        this.pbregelnbycatid = res;
        //this.oSelectedKategorieRegeln = res;
      });    
      
       
    }
    else{
      //-- New PbKat ------
      this.pbkat = {name:""
                  , preis:0
                  , dauer:365
                  , defaultvalid:1
                  , bestelltyp:0
                  , bestellbar:1
                  , bewilligungspflichtig:1
                  , sichtbar:0
                  , edited:"created"
                  , mandate_id: this.userData.mandate_mandid
                  , datum_von: this.common.minDateToday
                };
      this.updateBestellURL();
    }

  }

  loadPeriodcount(){
    if(!this.pbkat) return;
      
    this.pbData.pbcountbycatid(this.pbkat.id).then(res => {
      //console.log(res);
      let data: any = res;
      if(data && data.success === true){
        //console.log("pbcountbycatid: "+data.data);
        this.periodcount = data.data;          
      }
      else{
        console.log("error pbcountbycatid");
      }
      //this.oSelectedKategorieRegeln = res;
    });   
  }

  ionViewDidLoad() {
    //console.log(this.mandantenData.data);
  }

  validateInputs(){
    this.pbkat.name = this.pbkat.name.trim();    
    if (this.pbkat.name == ""){
      return -1;
    }
    if(this.pbkat.preis < 0){
      return -2;
    }
    if(!this.pbkat.mandate_id){
      return -3;
    }
    if((!(this.pbkat.dauer) || (this.pbkat.dauer<=0))  && this.pbkat.bestelltyp != PbKategorieTyp.Permanent){
      return -4;
    }
    if(!(this.pbkat.datum_von) && this.pbkat.bestelltyp == PbKategorieTyp.FixerZeitraum){
      return -5;
    }
    if(this.pbkat.dauer > 365){
      return -6;
    }
    

    return 1;
  }

  pbkatChange(event){
    //console.log(this.pbkat.edited);
    if(this.pbkat.edited != "created"){
      //console.log("changed");
      this.pbkat.edited = "changed";
    }
  }

  rulesChanged(event){
    //console.log("rulesChanged");
    this.pbkat.edited = "changed";    
  }  

  additionalFieldsChanged(event){
    //console.log("additional Fields Changed");
    this.pbkat.edited = "changed";    
  }

  showError(text: string){
    let toast = this.toastCtrl.create({
      message: text,
      position: 'top',
      cssClass: 'toast-error',
      duration: 3000
    });
    toast.present();         
  }
  showMessage(text: string){
    this.showError(text);
  }

  updateChanges(){
    
    switch(this.validateInputs()){
      case -2: this.showError('Preis kann nicht < 0 sein.');
               return;
      case -1: this.showError('Bitte Kategorie-Namen eingeben');
               return;
      case -3: this.showError('Bitte Mandat auswählen');
               return;
      case -4: this.showError('Dauer muss > 0 sein');
               return;
      case -5: this.showError('Bitte Startdatum wählen');
               return;
      case -6: this.showError('Dauer darf nicht länger als 365 Tage sein');
               return;
    }

    //-- Validate Zusatzfelder ------------
    //console.log("additionalfields");
    //console.log(this.additionalfields);
    if(this.additionalfields){
      let afvalidation = this.additionalfields.validate();
      //console.log("afvalidation:"+afvalidation);
      if(afvalidation != ""){
        this.showError(afvalidation);
        return;
      }
    }
    
    if(this.pbkat.bestelltyp != PbKategorieTyp.FixerZeitraum){
      delete this.pbkat.datum_von;
    }
    
    if(this.pbkat.edited =="changed"){
      this.pbData.updatepbkategorie(this.pbkat).then(res => {
        //console.log(res);
        if(!res){
          this.showError("Fehler beim Speichern");
          return;
        }
        else{
          
          this.pbkat = res;     
          this.updateBestellURL();
          this.loadPeriodcount();    
          this.showError("Speichern erfolgreich");
      }
      });       
    }
    else if(this.pbkat.edited =="created"){
      //console.log("create kat");
      //console.log(this.pbkat);
      
      this.pbData.createpbkategorie(this.pbkat).then(res => {
        //console.log(res);
        if(!res){
          this.showError("Fehler beim Speichern");
          return;
        }
        else{
          this.pbkat = res;     
          this.updateBestellURL();
          this.loadPeriodcount();    
          this.showError("Kategorie erfolgreich gespeichert");


        }
      });      
    }
    //-- Update Regeln -----
    if(this.catrules){
      this.catrules.updateChanges();
    }
    
    //-- Update Zusatzfelder ---------
    if(this.additionalfields){
      this.additionalfields.updateChanges();
    }   

    this.pbData.loadcategories();
  }

  delete(){
    this.pbData.deletepbkategorie(this.pbkat.id).then(res => {
      //console.log(res);
      //this.pbkat = res;
      this.pbData.loadcategories();
      this.navCtrl.pop();
      //this.oSelectedKategorieRegeln = res;
    });    

  }

  discardChanges(){
    this.pbData.pbcatbyid(this.pbkat.id).then(res => {
      this.pbkat = res;
      this.updateBestellURL();
      this.loadPeriodcount();    


      //this.oSelectedKategorieRegeln = res;
    });    
    //-- Update Regeln -----
    this.catrules.discardChanges();
  
  }
  updateBestellURL(){
    if(this.pbkat && this.pbkat.edited != 'created'){
      this.bestellurl = '/bestellen2?k='+this.pbkat.id+'&m='+this.pbkat.mandate_id;
    }
    else{
      this.bestellurl = 'nach dem Speichern ersichtlich';
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/pbkategorien/pbkategorien-edit/pbkategorien-edit.ts